import { useState } from "react";

const COLORS = ["#FF4B0A", "#042A65", "#FFB800", "#10B981", "#EC4899", "#0EA5E9"];

export function Confetti({ count = 130 }) {
  const [pieces] = useState(() =>
    Array.from({ length: count }, (_, i) => ({
      left: Math.random() * 100,
      delay: Math.random() * 0.7,
      dur: 2.6 + Math.random() * 1.9,
      color: COLORS[i % COLORS.length],
      size: 6 + Math.random() * 9,
      round: Math.random() > 0.5,
      drift: (Math.random() - 0.5) * 160,
    }))
  );
  return (
    <div className="pointer-events-none fixed inset-0 z-[60] overflow-hidden" data-testid="confetti" aria-hidden>
      {pieces.map((p, i) => (
        <span
          key={i}
          style={{
            position: "absolute",
            top: "-12vh",
            left: `${p.left}%`,
            width: p.size,
            height: p.round ? p.size : p.size * 0.42,
            background: p.color,
            borderRadius: p.round ? "9999px" : "2px",
            "--drift": `${p.drift}px`,
            animation: `confetti-fall ${p.dur}s ${p.delay}s cubic-bezier(.25,.6,.4,1) forwards`,
          }}
        />
      ))}
    </div>
  );
}
